/**
 * Kinng.app — Cliente de e-mail do Super Admin (IMAP/SMTP genérico · MAIL_*).
 * Ferramenta isolada dentro do Painel Mestre — ver backend routes/emails.py.
 */
import api from "./api";

const qs = (obj) =>
    Object.entries(obj)
        .filter(([, v]) => v !== undefined && v !== null && v !== "")
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join("&");

export const emailsApi = {
    status:  ()                          => api.get("/admin/emails/status"),
    unread:  ()                          => api.get("/admin/emails/unread"),
    folders: ()                          => api.get("/admin/emails/folders"),
    list:    (folder, page = 1, search = "") =>
        api.get(`/admin/emails?${qs({ folder, page, search })}`),
    message: (folder, uid)              =>
        api.get(`/admin/emails/message?${qs({ folder, uid })}`),
    send:    (body)                      => api.post("/admin/emails/send", body),
    trash:   (folder, uid)              => api.post("/admin/emails/trash", { folder, uid }),
};

export default emailsApi;
